export const checkShowLastElement = (showItemImages, showPrice, hasItemPriceObject, displaySubscriptionToggle, hasHandleRenewSwitch) => {
    const cond1 = !showItemImages && showPrice && hasItemPriceObject;
    const cond2 = displaySubscriptionToggle && hasHandleRenewSwitch;
    return cond1 || cond2;
};
